import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React from "react";
import { useEmployee } from "Hooks/AdminHooks/Organization/useEmployee";
import { Table } from "antd";

const EmployeeDirectory = () => {
  const { loading, employees, columns } = useEmployee();
  
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ padding: "24px" }}>
        <h2> Employees</h2>
        <Table className="custom-table" columns={columns} loading={loading} dataSource={employees} rowKey={"id"} />
      </div>
    </DashboardLayout>
  );
};
export default EmployeeDirectory;
